import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "cain-link-3" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "Vector",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M13.9009 4.09911C12.4354 2.63363 10.0594 2.63363 8.59391 4.09911L8.59043 4.1026L8.02683 4.65881C7.73202 4.94977 7.25715 4.94664 6.96619 4.65183C6.67523 4.35702 6.67836 3.88215 6.97317 3.59119L7.53507 3.03664C9.58648 0.987183 12.9109 0.987788 14.9615 3.03845C17.0122 5.08913 17.0128 8.41358 14.9633 10.465C14.9627 10.4656 14.9621 10.4662 14.9616 10.4667L14.4088 11.0268C14.1178 11.3216 13.643 11.3248 13.3482 11.0338C13.0534 10.7428 13.0502 10.268 13.3412 9.97317L13.9009 9.40607C15.3664 7.94059 15.3664 5.56459 13.9009 4.09911ZM4.65183 6.96619C4.94664 7.25715 4.94977 7.73202 4.65881 8.02683L4.09912 8.59393C2.63364 10.0594 2.63363 12.4354 4.09911 13.9009C5.56459 15.3664 7.94061 15.3664 9.40609 13.9009L9.40957 13.8974L9.97317 13.3412C10.268 13.0502 10.7428 13.0534 11.0338 13.3482C11.3248 13.643 11.3216 14.1178 11.0268 14.4088L10.4667 14.9615C10.4661 14.9622 10.4655 14.9628 10.4649 14.9634C8.41352 17.0128 5.08911 17.0122 3.03845 14.9615C0.987786 12.9109 0.987182 9.58647 3.03664 7.53506L3.59119 6.97317C3.88215 6.67836 4.35702 6.67523 4.65183 6.96619ZM11.0303 6.96967C11.3232 7.26256 11.3232 7.73744 11.0303 8.03033L8.03033 11.0303C7.73744 11.3232 7.26256 11.3232 6.96967 11.0303C6.67678 10.7374 6.67678 10.2626 6.96967 9.96967L9.96967 6.96967C10.2626 6.67678 10.7374 6.67678 11.0303 6.96967Z",
    fill: "currentColor"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }